import reducer from './page-header.reducer'
import { NAME } from './page-header.constants'

export * from './page-header.action'

export { NAME, reducer }
